import { NextSeo } from "next-seo";
import ReportHero from "@/components/pages/on-their-own-terms/hero";

export default function OnTheirOwnTerms() {
  return (
    <>
      <NextSeo
        title="On Their Own Terms"
        description="Survivors' Idea of Dignity and Justice — 168 survivors of sexual violence, 160 family members, and 192 justice system actors across Bangladesh, India, Indonesia, Nepal, the Philippines and Sri Lanka on what justice means to them."
        canonical="https://dignityallianceinternational.org/on-their-own-terms"
      />
      <ReportHero />
    </>
  );
}
